import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { Language } from '@/lib/i18n';

export function LanguageToggle(): JSX.Element {
  const { i18n, t } = useTranslation();
  const next: Language = i18n.language === 'ar' ? 'en' : 'ar';
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => void i18n.changeLanguage(next)}
      aria-label={t('common.language')}
      className="gap-2"
    >
      <Languages className="h-4 w-4" aria-hidden="true" />
      <span>{next === 'ar' ? t('common.language_ar') : t('common.language_en')}</span>
    </Button>
  );
}
